import { Observable } from 'rxjs';
import { computed, signal } from '@angular/core';
import { SearchDtoBase } from '@myarvato/shared/models';

export interface SearchFieldResult {
  propertyName: string;
  highlightedValue: string;
}

export abstract class BaseSearchService<T extends SearchDtoBase> {
  protected readonly _searchResultTotalCount = signal<number>(0);
  public readonly searchResultTotalCount = computed(() => this._searchResultTotalCount());

  abstract getSearchIndex(searchTerm: string): Observable<T[]>;

  abstract findSearchField(item: SearchDtoBase, searchTerm: string): SearchFieldResult | null;
}
